// src/Pages/About.jsx
import * as React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { ThemeProvider, createTheme, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import Footer from "./Footer.jsx";

import pic from "./Photographies/photography/tq1yA46.jpeg";
import pic2 from "./Photographies/photography/s7vJf9z.jpg";
import catto from "./Photographies/photography/catto.png";

export default function About() {
  const base = createTheme();

  const theme = createTheme({
    typography: {
      fontFamily: "Helvetica",
      h1: { fontSize: "3rem", fontWeight: 200 },
      body1: {
        fontSize: "1.25rem",
        fontWeight: 200,
        lineHeight: 1.5,
        [base.breakpoints.down("sm")]: {
          fontSize: "1.25rem",
          fontWeight: 300,
        },
      },
      captionCustom: {
        fontSize: "0.8rem",
        color: "gray",
        textAlign: "center",
        fontWeight: 400,
        marginTop: "2vh",
        marginBottom: "2vh",
        display: "block",
        width: "100%",
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        marginTop="5vh"
        paddingBottom="10vh"
        maxWidth="100vw"
      >
        <Grid
          container
          direction="column"
          alignItems="center"
          spacing={4}
          width="90vw"
        >
          {/* Title */}
          <Grid item>
            <Typography
              variant="h1"
              component={Link}
              to="/"
              sx={{
                color: "inherit",
                textDecoration: "none",
                cursor: "pointer",
              }}
            >
              // about
            </Typography>
          </Grid>

          {/* Catto image */}
          <Grid item>
            <Box
              component="img"
              src={catto}
              alt="Catto"
              loading="lazy"
              sx={{
                display: "block",
                mx: "auto",
                width: { xs: "35%", sm: "15%" },
              }}
            />
          </Grid>

          {/* Text + images inside same proportional container */}
          <Grid item width="100%">
            <Box sx={{ width: { xs: "100%", sm: "80%" }, mx: "auto" }}>
              <Typography variant="body1" sx={{ mb: "3vh" }}>
                <b>
                  russian-born switzerland-based artist
                </b>
              </Typography>

              <Typography
                variant="body1"
                sx={{ textAlign: "right", mb: "5vh" }}
              >
                <b>
                  busy producing music as Leonid, DJing as{" "}
                  <i>I Date Models</i>, taking photographs, writing, and
                  thinking about cinema
                </b>
              </Typography>

              <Typography variant="body1" sx={{ mb: "3vh" }}>
                // between Aug 20th and Sep 4th 2022 the project{" "}
                <Link to="/ph/pahf">"post-apocalyptic high fashion"</Link> was
                exhibited at{" "}
                <a
                  href="https://www.gallerialaloggia.ch"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Galleria La Loggia
                </a>
              </Typography>

              <Typography variant="body1" sx={{ mb: "3vh" }}>
                // between Mar 2nd and Jun 2nd 2023 the F4 manifesto{" "}
                <a
                  href="https://www.instagram.com/p/CpkcrBcqXdx/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  "mute expression"
                </a>{" "}
                was exhibited at{" "}
                <a
                  href="https://www.instagram.com/p/CpYHKGuK-ad"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  SUPSI Mendrisio
                </a>
              </Typography>

              <Typography variant="body1" sx={{ mb: "3vh" }}>
                // between Apr 19th and Jun 19th 2023 my photos from{" "}
                <a
                  href="./ph/ukraine2022"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Ukraine
                </a>{" "}
                were exhibited at{" "}
                <a
                  href="https://www.unifr.ch"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  UNIFR
                </a>

                {" "}for the expo "La Résilience"
              </Typography>

              <Typography variant="body1" sx={{ mb: "3vh" }}>
                // on december 2nd 2023 I published{" "}
                <a
                  href="https://share.amuse.io/album/leonid-making-moves-on-the-dancefloor"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Making Moves on the Dancefloor
                </a>
                , a 7-track EP, and hosted a{" "}
                <a
                  href="https://www.instagram.com/p/C0wDwKLN7sS/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  release party
                </a>
              </Typography>

              <Typography variant="body1" sx={{ mb: "3vh" }}>
                // on february 7th 2025 I published{" "}
                <a
                  href="https://share.amuse.io/album/leonid-at-the-edge"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  AT THE EDGE
                </a>
                , an 11-track LP, and organized the{" "}
                <a
                  href="https://www.instagram.com/p/DF-A8ZSNJr2/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  release party
                </a>
              </Typography>

              <Typography variant="body1" sx={{ mb: "3vh" }}>
                // between May 29th and June 27th 2025{" "}
                <Link to="/ph/untitledbodyproject">
                  "untitled body project"
                </Link>{" "}
                was exposed at cinema{" "}
                <a
                  href="https://www.korso.ch"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Korso Fribourg
                </a>
              </Typography>

              <Typography variant="body1" sx={{ mb: "3vh" }}>
                // between Oct 10th and Oct 31st 2025 the project{" "}
                <a
                  href="https://www.instagram.com/p/DPtd7VciGaw/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  "transfusions"
                </a>{" "}
                was exhibited at{" "}
                <a
                  href="https://www.abpi.ch/rouge-dici-et-doutre-ailleurs"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Fondation ABPI
                </a>{" "}
                in Lausanne
              </Typography>

              {/* Images */}
              <Box sx={{ mt: "5vh" }}>
                <img
                  src={pic2}
                  width="100%"
                  alt="Photography"
                  loading="lazy"
                />
                <Typography variant="captionCustom">
                  ^ 07.02.2025 // AT THE EDGE RELEASE PARTY // at the center
                  Leonid Pesenti (I Date Models), on the right is a tapestry by{" "}
                  <a href="https://www.berenicecourtin.com">
                    Bérénice Gaca Courtin
                  </a>{" "}
                  ^
                </Typography>
              </Box>

              <Box sx={{ mt: "3vh" }}>
                <img
                  src={pic}
                  width="100%"
                  alt="Photography"
                  loading="lazy"
                />
                <Typography variant="captionCustom">
                  ^ 03.2023 // shooting of{" "}
                  <Link to="/ph/pahf">"post-apocalyptic high fashion"</Link> ^
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Footer />
    </ThemeProvider>
  );
}
